import validate from "/builds/tra/webshop/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import custom_45router_45global from "/builds/tra/webshop/frontend/node_modules/@xsarus-npm/nuxt3-base/src/nuxt3-base/app/middleware/customRouter.global.ts";
import manifest_45route_45rule from "/builds/tra/webshop/frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  custom_45router_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}